// Local translations
export const T = {
  en_GB: {
    signedInAs: "The app will act as",
    useAnother: "Use another account or organization",
  },
  nb_NO: {
    signedInAs: "Appen vil handle som",
    useAnother: "Bruk en annen konto eller organisasjon",
  },
} as const;
